module.exports = __webpack_public_path__ + "static/media/rnaapp_110.b880ef3b.ico";